import {
  Instance_event_eventContext,
  Merged_event_eventContext,
  Selected_sequence_eventContext,
  Unselected_sequence_eventContext,
} from '@verantos-dev/util-cohort-builder-typescript-runtime';

export const getEventName = (
  event?:
    | Instance_event_eventContext
    | Merged_event_eventContext
    | Selected_sequence_eventContext
    | Unselected_sequence_eventContext
    | null
): string => {
  const simpleEvent = event?.qualified_simple_event();
  const derivedEvent = event?.qualified_derived_event();
  if (simpleEvent) {
    if (simpleEvent?.QUALIFIED_CONDITION_OCCURRENCE_ALIAS()) {
      return (
        simpleEvent.QUALIFIED_CONDITION_OCCURRENCE_ALIAS()?.getText().replace('QUALIFIED_', '') ||
        ''
      );
    }
    if (simpleEvent?.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS()) {
      return (
        simpleEvent.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS()?.getText().replace('QUALIFIED_', '') ||
        ''
      );
    }
    if (simpleEvent?.QUALIFIED_DRUG_EXPOSURE_ALIAS()) {
      return simpleEvent.QUALIFIED_DRUG_EXPOSURE_ALIAS()?.getText().replace('QUALIFIED_', '') || '';
    }
    if (simpleEvent?.QUALIFIED_MEASUREMENT_ALIAS()) {
      return simpleEvent.QUALIFIED_MEASUREMENT_ALIAS()?.getText().replace('QUALIFIED_', '') || '';
    }
    if (simpleEvent?.QUALIFIED_OBSERVATION_ALIAS()) {
      return simpleEvent.QUALIFIED_OBSERVATION_ALIAS()?.getText().replace('QUALIFIED_', '') || '';
    }
    if (simpleEvent?.QUALIFIED_VISIT_OCCURRENCE_ALIAS()) {
      return (
        simpleEvent.QUALIFIED_VISIT_OCCURRENCE_ALIAS()?.getText().replace('QUALIFIED_', '') || ''
      );
    }
  }
  if (derivedEvent) {
    return derivedEvent?.QUALIFIED_DERIVED_EVENT_NAME()?.getText().replace('QUALIFIED_', '') || '';
  }

  return '';
};

export const getEventDateAttributes = (
  event?:
    | Instance_event_eventContext
    | Merged_event_eventContext
    | Selected_sequence_eventContext
    | Unselected_sequence_eventContext
    | null
): string => {
  const simpleEvent = event?.qualified_simple_event();
  const derivedEvent = event?.qualified_derived_event();
  if (simpleEvent) {
    if (simpleEvent?.CONDITION_OCCURRENCE_DATE_ATTRIBUTE()) {
      return simpleEvent.CONDITION_OCCURRENCE_DATE_ATTRIBUTE()?.getText() || '';
    }
    if (simpleEvent?.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE()) {
      return simpleEvent.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE()?.getText() || '';
    }
    if (simpleEvent?.DRUG_EXPOSURE_DATE_ATTRIBUTE()) {
      return simpleEvent.DRUG_EXPOSURE_DATE_ATTRIBUTE()?.getText() || '';
    }
    if (simpleEvent?.MEASUREMENT_DATE_ATTRIBUTE()) {
      return simpleEvent.MEASUREMENT_DATE_ATTRIBUTE()?.getText() || '';
    }
    if (simpleEvent?.OBSERVATION_DATE_ATTRIBUTE()) {
      return simpleEvent.OBSERVATION_DATE_ATTRIBUTE()?.getText() || '';
    }
    if (simpleEvent?.VISIT_OCCURRENCE_DATE_ATTRIBUTE()) {
      return simpleEvent.VISIT_OCCURRENCE_DATE_ATTRIBUTE()?.getText() || '';
    }
  }
  if (derivedEvent) {
    return derivedEvent?.DERIVED_EVENT_DATE()?.getText() || '';
  }

  return '';
};
